import { Component, OnInit } from '@angular/core';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { HeaderService } from 'src/app/shared/services/header/header.service'
import { LoginService } from 'src/app/shared/services/login/login.service';
import { ManagersService } from 'src/app/shared/services/managers/managers.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import * as _ from 'lodash'
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { NgIf, NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
@Component({
    selector: 'app-change-access-level',
    templateUrl: './change-access-level.component.html',
    styleUrls: ['./change-access-level.component.scss'],
    imports: [NgIf, NgFor, TranslateModule]
})
export class ChangeAccessLevelComponent implements OnInit {

  applyDisabled: boolean = true;
  managerAccess: any = [];
  object: any = {};
  defaultGroupKey = '';
  toSetDefaultGroupKey = '';
  accessDefaultGroupKey = '';
  actionPerform = { 'group_key': '', 'group_name': '', 'group_value': '', 'index': -1 };
  setDefault = true;
  manager: any = {};
  loggedInManager: any = {};
  action: any = [];
  accessPresent: any = false;
  loaderMessage: string = 'Please wait';
  isRequestSubmitted: boolean = false;

  constructor(
    private headerService: HeaderService,
    private globalFilterService: GlobalFilterService,
    private loginService: LoginService,
    private managers: ManagersService,
    private _helpers: HelpersService,
    private _toast: ToastService,
  ) { }

  ngOnInit(): void {
    this.toSetDefaultGroupKey = '';
    this.accessDefaultGroupKey = '';
    this.isRequestSubmitted = false;
    this.globalFilterService.globalFilterState$.subscribe(state => {
      this.object = state;
    })
    this.getManagerAccessDetails();
  }
  apply(event: any) {
    this.isRequestSubmitted = true;
    event.preventDefault();
    if (this.actionPerform.index != -1) {
      let pos = this.action.map(e => e.action_type).indexOf(2);
      if (pos == -1) {
        this.action.push(this.actionPerform);
      } else {
        this.action[pos] = this.actionPerform;
      }
    }
    var data = {}; // Parameter to pass in API
    if (this.action.length == 2 && this.actionPerform.group_value != "") {
      if ((this.action[0].group_key == this.action[1].group_key) || (this.action[0].group_key != this.action[1].group_key)) {
        data['group_key'] = this.action[0].group_key || this.action[1].group_key;
        data['group_value'] = this.action[1].group_value;
        data['project_id'] = this.object.project_id;
        this.actionPerformToSetAsDefault(data, 'default_with_temp');
      } else {
        // Frist perform action to set the group_key as default & then set the temporary for other group_key
        data['group_key'] = this.action[0].group_key;
        data['project_id'] = this.object.project_id;
        this.actionPerformToSetAsDefault(data, 'default');
      }
    } else {
      if ((this.action[0] && this.action[0].action_type == 1) || (this.action[1] && this.action[1].action_type == 1)) {
        data['group_key'] = this.action[0].group_key || this.action[1].group_key;
        data['project_id'] = this.object.project_id;
        this.actionPerformToSetAsDefault(data, 'default');
      } else {
        this.actionPerformToSetAsTemp(data);
      }
    }
  }
  actionPerformToSetAsDefault(data, type) {
    this.managers.setAsDefaultAccess(data).subscribe(response => {
      if (response.data && response.data.code == 0) {
        // Handle success message here
        if (type == 'default_with_temp') {
          this.actionPerformToSetAsTemp(this.action)
        }
        if (type == 'default') {
          this._toast.showPopup('SUCCESS', 'Success', 'New permissions updated. Changes will take effect on next login.', 5000)
          this.close()
        }
        this.action = [];
      } else {
        this._toast.showPopup('ERROR', 'Error', "Something went wrong. Please try again.", 5000);
      }
    })
  }

  actionPerformToSetAsTemp(param) {
    if (this.actionPerform['action_type'] == 2) {
      let data = {};
      data['group_key'] = this.actionPerform.group_key;
      data['project_id'] = this.object.project_id;
      data['selected_id'] = this.object.project_id;
      data['manager_type'] = 2;
      // Set applied group_key, to witch new level access
      // Set current loggedInManager while switching new level's value
      if (this.actionPerform.group_key != this.loggedInManager.group_key) {
        this.managers.switchAccess(data).subscribe(response => {
          if (response && response.code == 0 && response.data && response.data.code == 0) {
            // If both default & switch access level applied
            if(data && param.length == 2) {
              this._toast.showPopup('SUCCESS', 'Success', 'Access level updated. Please refresh the page if any issues arise. New permissions for default access will take effect on next login.', 5000)
            }else {
              this._toast.showPopup('SUCCESS', 'Success', 'Access level updated. Please refresh the page if any issues arise.', 5000)
            }
          } else {
            this._toast.showPopup('ERROR', 'Error', "Something went wrong. Please try again.", 5000);
            // #todo, have to handle below part, if error comes
          }
        })
      } else {
        if(param && param.length == 2) {
          this._toast.showPopup('SUCCESS', 'Success', 'Access level updated. Please refresh the page if any issues arise. New permissions for default access will take effect on next login.', 5000)
        }else {
          this._toast.showPopup('SUCCESS', 'Success', 'Access level updated. Please refresh the page if any issues arise.', 5000)
        }
      }
      // Set selected value in Helpers & hierarchy
      let access_values = this.actionPerform['access_key'][this.actionPerform.group_key];
      if (access_values.values.length > 0) {
        let access_key: any = {};
        access_key[this.actionPerform.group_key] = access_values;
        this.loggedInManager['group_key'] = this.actionPerform.group_key;
        this.loggedInManager['group_name'] = this.actionPerform.group_name;
        this.loggedInManager['group_value'] = this.actionPerform.group_value;
        this.loggedInManager['index'] = this.actionPerform.index;
        delete this.loggedInManager['access_key'];
        this.loggedInManager['access_key'] = access_key;
        let hierarchyStack: any = [];
        let group_key: any = [];
        group_key.push(this.actionPerform.group_value);
        hierarchyStack.push({ field_id: this.actionPerform.group_key, group_key: group_key })
        let appliedHierarchy: any = {};
        appliedHierarchy['by_hierarchy_drilldown'] = [{
          enabled: true,
          isDropDownOpen: false,
          key: this.actionPerform.group_key,
          label: this.object.mappedHierarchyLevelNames[this.actionPerform.group_key],
          options: access_values['values'],
          value: this.actionPerform.group_value
        }]
        let cohortAccess: any = (access_values && _.hasIn(access_values, "cohort_fields") && !_.isEmpty(access_values.cohort_fields)) ? access_values.cohort_fields : {}
        this.prepareAndApplyCohortAccess(cohortAccess).then((filter: any) => {
          this.globalFilterService.setValuesForGlobalUse({ newAccess: this.loggedInManager, type: 'switchToThisLevel' });
          this.globalFilterService.setValuesForGlobalUse({ globalFilter: appliedHierarchy, type: 'applied_hierarchy_filter' }); // Set new applied hierarchy filter also render into global filter side bar
          // this._helpers.setHierarchyStack(hierarchyStack) // Set new hierarchyStack for global use, if switch to this level triggered
          this._helpers.updateAccess(hierarchyStack, filter)
          this.close()
        })

      }
    }
  }
  // Close modal
  close() {
    this.action = [];
    this.headerService.changeAccessLevelContainerVisibility(false); // close modal
  }
  getManagerAccessDetails() {
    this.manager = _.get(Helpers, "managerDetails.manager");
    this.loggedInManager = _.get(Helpers, "managerDetails.loggedInManager");
    // Draw manager access for project level access
    if(this.loggedInManager && this.loggedInManager.manager_type != 3) {
      this.drawMangerAccess();
    }
  }
  drawMangerAccess() {
    let hierarchyStack = Helpers.getHierarchyStack();
    var access = this.manager['manager_access'];
    if (this.loggedInManager && this.loggedInManager.account_id == this.object.account_id && this.loggedInManager.brand_id == this.object.project_id) {
      let index = 0;
      if (this.loggedInManager && _.has(this.loggedInManager, 'index')) {
        index = this.loggedInManager['index'];
      }
      this.defaultGroupKey = this.loggedInManager.group_key;
      this.actionPerform['action_type'] = 2;
      this.actionPerform['group_key'] = this.defaultGroupKey;
      this.actionPerform['index'] = index;
      this.actionPerform['access_key'] = this.loggedInManager.access_key;
    }
    // If value changed from hierarchy header set the index to activate the chip in Change User Access component
    if (hierarchyStack && hierarchyStack[0] && hierarchyStack[0].group_key && hierarchyStack[0].group_key[0]) {
      let pos = this.loggedInManager.access_key[this.defaultGroupKey].values.indexOf(hierarchyStack[0].group_key[0]);
      this.actionPerform['index'] = pos;
    }
    for (var i = 0; i < access.length; i++) {
      if (access[i].account_id == this.object.account_id && access[i].brand_id == this.object.project_id && access[i].access_expired_on == null && access[i].is_verified == true) {
        if(access[i].is_default_access) {
          this.toSetDefaultGroupKey = access[i].group_key;
          this.accessDefaultGroupKey = this.toSetDefaultGroupKey;
        }
        this.managerAccess.push(access[i])
      }
    }
    if (this.managerAccess.length > 0) {
      this.accessPresent = true;
    } else {
      this.accessPresent = false;
    }
  }
  setAsDefault(group_key, event, type) {
    this.action = [];
    this.setDefault = true;
    if (event && event.target && event.target.checked) {
      // Prevent apply, if selecting same with previous default group key
      if (group_key && (group_key !== this.defaultGroupKey || group_key !== this.accessDefaultGroupKey)) {
        this.action.push({ 'action_type': type, 'group_key': group_key });
        this.toSetDefaultGroupKey = group_key;
        this.applyDisabled = false;
      }else {
        this.applyDisabled = true;
      }
    }
  }
  switchAccessLevel(group_key, event, index, access_key, type) {
    if (type == 2) {
      this.setDefault = false;
      if (group_key) {
        this.actionPerform['action_type'] = type;
        this.actionPerform['group_key'] = group_key;
        this.actionPerform['group_name'] = event.target.innerText;
        this.actionPerform['group_value'] = event.target.innerText;
        this.actionPerform['index'] = index;
        this.actionPerform['access_key'] = access_key;
        this.applyDisabled = false;
        // Prevent apply, if selecting same with previous applied value
        let hierarchyStack = this._helpers.getHierarchyStack();
        if(!_.isEmpty(hierarchyStack) && hierarchyStack.length > 0) {
          let groupKeys = hierarchyStack[0].group_key;
          let selectedGroupKey = access_key[group_key].values[index];
          if(groupKeys.indexOf(selectedGroupKey) != -1) {
            this.applyDisabled = true
          }
        }
      }
    }
  }
  // Activate chip with default value
  isChosen(group_key) {
    var selectedBrandInfo: any = this.loggedInManager
    if (selectedBrandInfo && selectedBrandInfo.access_key && Object.keys(selectedBrandInfo.access_key)[0]) {
      var selectedGroupKey = selectedBrandInfo.group_key || Object.keys(selectedBrandInfo.access_key)[0];
      if (group_key == selectedGroupKey) {
        return 'activated-chip';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  // this is temprory in future if its not required we can remove this code becuase same code is written in app state service
  prepareAndApplyCohortAccess(cohortAccess) {
    return new Promise((resolve) => {
      let filterMapping = this.globalFilterService.getGolbalFilters();
      let universalFilter = this.globalFilterService.getUniveralFilters();
      let appliedFilters: any = []
      if (_.isEmpty(universalFilter)) {
        universalFilter = {
          isAppliedFromAccount: false,
          filters: []
        }
      }
      const tagFilter = filterMapping['transaction_filter'];
      let filters: any = []
      if (cohortAccess && !_.isEmpty(cohortAccess) && tagFilter && tagFilter.filters && tagFilter.filters.length) {
        _.each(cohortAccess, (data: any, key: string) => {
          const filter: any = _.find(tagFilter.filters, { field_id: key })
          if (data && data.length && filter && !_.isEmpty(filter)) {
            let details: any = [];
            _.each(data, (value: any) => {
              if (value) {
                details.push({
                  "text": value,
                  "value": value
                })
              }
            })
            filters.push(
              {
                "filterType": "transaction_filter",
                "fieldId": filter?.field_id || key,
                "fieldText": filter?.name || filter?.text,
                "operator": "eq",
                "isMultiSelect": false,
                "isAccessLevelFilter": true,
                "operatorText": "Equal To",
                "valueText": data.join(","),
                "values": data,
                "labels": data,
                "details": details,
                "possibleValues": data,
                "filterText": "Metadeta",
              }
            )
          }

        })

        if (filters && filters.length) {
          universalFilter.filters = filters;
        } else {
          universalFilter.filters = _.filter(universalFilter.filters, (filter: any) => {
            return (filter.isAccessLevelFilter != true)
          })
        }
      } else {
        universalFilter.filters = _.filter(universalFilter.filters, (filter: any) => {
          return (filter.isAccessLevelFilter != true)
        })

      }
      const formatedFilters = this.globalFilterService.getFormatedUniversalFilter(universalFilter.filters);
      this.globalFilterService.storeUniversalFilters(universalFilter);
      resolve(formatedFilters)
    })

  }


}
